import { Injectable } from "@angular/core";

// The partner request each selected partner rate was priced for, by rate id. Root-provided because
// the freight tab is destroyed while the quote is edited on another tab; a page reload forgets it.
@Injectable({ providedIn: "root" })
export class PartnerRateSelectionService {
  private criteriaByRate = new Map<number, string>();

  public remember(rateId: number, criteria: string): void {
    this.criteriaByRate.set(rateId, criteria);
  }

  public criteriaOf(rateId: number): string {
    return this.criteriaByRate.get(rateId) ?? null;
  }

  public forget(rateId: number): void {
    this.criteriaByRate.delete(rateId);
  }
}
